import React, { ReactElement } from 'react'
import ServiceBlockingIcon from 'images/organization/features/malware/devices.svg'
import NetworkLevelIcon from 'images/organization/features/malware/network.svg'
import TrustedIcon from 'images/organization/features/malware/trusted.svg'
import AnalyticsIcon from 'images/organization/features/malware/analytics.svg'
import CompactFeatures, {
  FeaturesDivider,
  FeaturesItem,
} from 'components/Organization/LandingPageCommonComponents/CompactFeatures'
import FrequentlyAskedQuestions from 'components/FrequentlyAskedQuestions'
import { frequentlyAskedQuestions } from './Sections/frequentlyAskedQuestions'
import ComprehensiveServiceFiltering from './Sections/ComprehensiveServiceFiltering'
import ReadyToGetStarted from '../CommonSections/RedyToGetStarted'
import ServiceFilteringUseCases from './Sections/UseCases/ServiceFilteringUseCases'
import SectionDivider from 'components/Organization/LandingPageCommonComponents/SectionDivider'
import TrustedByExperts from 'components/Organization/Features/TrustedByExperts/TrustedByExperts'
import FeaturePageLayout from 'components/Organization/LandingPageCommonComponents/LandingPageLayout'
import { CONTROLDText } from 'ui/CONTROLD'
import HeroIcon from 'images/organization/features/serviceFiltering/hero.svg'
import HeroSection from 'components/Organization/LandingPageCommonComponents/HeroSection'

export default function ServiceFiltering(): ReactElement {
  return (
    <FeaturePageLayout>
      <HeroSection
        title="Service Filtering DNS Platform"
        description={`${CONTROLDText} allows you to block or allow specific online services or apps. From social
            media to streaming, ${CONTROLDText}’s service filtering makes it easy to manage how services
            are accessed across your organization.`}
        svg={HeroIcon}
      />

      <CompactFeatures>
        <FeaturesItem icon={ServiceBlockingIcon} title="Customizable service blocking" />
        <FeaturesDivider />
        <FeaturesItem icon={NetworkLevelIcon} title="Network level control" />
        <FeaturesDivider />
        <FeaturesItem icon={TrustedIcon} title="Trusted by experts" />
        <FeaturesDivider />
        <FeaturesItem icon={AnalyticsIcon} title="Detailed usage analytics" />
      </CompactFeatures>

      <ServiceFilteringUseCases />
      <SectionDivider />

      <ComprehensiveServiceFiltering />
      <SectionDivider />

      <TrustedByExperts />
      <SectionDivider />

      <FrequentlyAskedQuestions data={frequentlyAskedQuestions} />
      <SectionDivider />

      <ReadyToGetStarted />
    </FeaturePageLayout>
  )
}
